export default __webpack_public_path__ + "static/Dudu Alignment-cffcf36ce878cb5cd9399235ab4eed0d.png";